import { useQuery, useQueryClient } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';
import { Issue, Project, ProjectEpic } from 'types';

const fetchProjectEpics = async (projectId: string): Promise<ProjectEpic[]> => {
  const { data } = await customAxios.get<ProjectEpic[]>(
    `/projects/${projectId}/epics`
  );
  return data;
};

const buildProjectEpics = (project?: Project<Issue>) => {
  if (!project) {
    return [];
  }

  const issues = [
    ...project.todoIssues,
    ...project.inProgressIssues,
    ...project.inReviewIssues,
    ...project.deploymentIssues,
    ...project.completedIssues,
  ];

  return issues
    .filter((issue) => issue.type === 'epic')
    .map((issue) => ({
      _id: issue._id,
      title: issue.title,
      jiraKey: issue.jiraKey,
    }));
};

export const useGetProjectEpics = (projectId?: string) => {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: ['projects', projectId, 'epics'],
    queryFn: () => {
      if (!projectId) {
        return Promise.resolve([] as ProjectEpic[]);
      }
      return fetchProjectEpics(projectId);
    },
    enabled: Boolean(projectId),
    initialData: projectId
      ? buildProjectEpics(
          queryClient.getQueryData<Project>(['projects', projectId])
        )
      : undefined,
  });
};
